<template>
  <el-container height="auto">
    <el-main style="margin:0px;padding:0px;padding-right:20px;">
      <el-container style="margin:0px;padding:0px;">
        <el-header style="margin:0px;padding:0px;padding-bottom:5px;height:35px;">
          <el-row type="flex" justify="end">
            <el-col :span="12">
              <el-link  style="font-size:16px;" :underline="false" @click="reloadList">
                我的笔记
                <i class="el-icon-refresh el-icon--right" style="font-size:20px;"></i>
              </el-link>
            </el-col>
            <el-col :span="12" style="text-align:right;padding-right:15px;">
               <el-popover
                placement="bottom"
                title=""
                width="400"
                trigger="click"
                style="cursor:pointer;"
                >
                <div>
                  <span >应用类型</span><br>
                </div>
                <div style="margin-top:10px;">
                  <!-- <el-avatar slot="reference" shape="square"  size="large">
                    <font size="5"><i class="el-icon-user':'el-icon-tickets'"></i></font>
                  </el-avatar>
                  <el-avatar slot="reference" shape="square"  size="large">
                    <font size="5"><i :class="scope.row.category=='SUBJECT'?'el-icon-user':'el-icon-tickets'"></i></font>
                  </el-avatar> -->
                </div>

                <div>
                  <span >星标</span><br>
                </div>
                <div style="margin-top:10px;">

                  <span class="fa-stack fa-2x" @click="filterstarflag(5)" >
                    <i class="fa fa-square-o fa-stack-2x" v-if="(filter_starflag !='' && (filter_starflag).indexOf(5)!= -1)" ></i>
                    <i class="fa fa-star fa-stack-1x starflag_5" ></i>
                  </span>
                  <span class="fa-stack fa-2x" @click="filterstarflag(4)">
                    <i class="fa fa-square-o fa-stack-2x" v-if="(filter_starflag !='' && (filter_starflag).indexOf(4)!= -1)" ></i>
                    <i class="fa fa-star fa-stack-1x starflag_4" ></i>
                  </span>
                  <span class="fa-stack fa-2x" @click="filterstarflag(3)">
                    <i class="fa fa-square-o fa-stack-2x" v-if="(filter_starflag !='' && (filter_starflag).indexOf(3)!= -1)" ></i>
                    <i class="fa fa-star fa-stack-1x starflag_3" ></i>
                  </span>
                  <span class="fa-stack fa-2x" @click="filterstarflag(2)">
                    <i class="fa fa-square-o fa-stack-2x" v-if="(filter_starflag !='' && (filter_starflag).indexOf(2)!= -1)" ></i>
                    <i class="fa fa-star fa-stack-1x starflag_2" ></i>
                  </span>
                  <span class="fa-stack fa-2x" @click="filterstarflag(1)">
                    <i class="fa fa-square-o fa-stack-2x" v-if="(filter_starflag !='' && (filter_starflag).indexOf(1)!= -1)" ></i>
                    <i class="fa fa-star fa-stack-1x starflag_1" ></i>
                  </span>
                  <span class="fa-stack fa-2x" @click="filterstarflag(0)">
                    <i class="fa fa-square-o fa-stack-2x" v-if="(filter_starflag !='' && (filter_starflag).indexOf(0)!= -1)" ></i>
                    <i class="fa fa-star fa-stack-1x starflag_0" ></i>
                  </span>

                </div>               
                <el-divider content-position="left"></el-divider>
                 <div>标签</div>  
                  <el-tag
                    :key="index"
                    v-for="(tag,index) in tags"
                    :type="(filter_tag !='' && (filter_tag).indexOf(tag.tagname)!= -1)?'':'info'"
                    :disable-transitions="false"
                    @click="filterTag(tag)"
                    style="cursor:pointer;"
                    effect="plain"
                  >
                    {{tag.tagname}} {{tag.num>0?'('+tag.num+')':''}}
                  </el-tag>
                  <el-link v-if="this.tagminnum==1" style="color:gray;font-size:12px;" :underline="false" @click="showFilterTag(0)"><i>显示未分配标签</i></el-link>
                  <el-link v-if="this.tagminnum!=1" style="color:gray;font-size:12px;" :underline="false" @click="showFilterTag(1)"><i>隐藏未分配标签</i></el-link>
                  
                  <br>
                  <div style="float:right">
                    <el-button size="mini" type="primary" @click="resetFilter">重置</el-button>
                  </div>

                <el-link slot="reference" :underline="false">
                  
                  {{(this.filter_tag != '' || this.filter_starflag != '') ?'已筛选':'筛选'}}
                  <i class="fa fa-filter" style="font-size:20px;"></i>
                
                  
                </el-link>
              </el-popover>
            </el-col>
          </el-row>
        </el-header>
        <el-main style="margin:0px;padding:0px;">
            <el-table :data="computedTableData" :show-header="false" @row-click="showInfo">
              <el-table-column label="头像" align="right" width="50px;">
                <template slot-scope="scope">
                  <el-avatar slot="reference" shape="square"  size="large">
                    <font size="5"><i :class="scope.row.category=='SUBJECT'?'el-icon-user':'el-icon-tickets'"></i></font>
                  </el-avatar>
                </template>
              </el-table-column>
              <el-table-column label="星标" align="right" width="30px;">
                <template slot-scope="scope">
                  <el-dropdown @command="flagStar" trigger="click">
                    <span class="el-dropdown-link">
                      <i v-if="scope.row.starflag||'' != '' " :class="'fa fa-star starflag_' + scope.row.starflag" style="font-size:20px;"></i>
                      <i v-else class='fa fa-star-o starflag' style="font-size:20px;"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" >
                      <el-dropdown-item :command="composeValue('5',scope.row.formid)"> 
                        <i class="fa fa-star starflag_5" style="font-size:20px;"></i>             
                      </el-dropdown-item>
                      <el-dropdown-item :command="composeValue('4',scope.row.formid)"> 
                        <i class="fa fa-star starflag_4" style="font-size:20px;"></i>                 
                      </el-dropdown-item>
                      <el-dropdown-item :command="composeValue('3',scope.row.formid)"> 
                        <i class="fa fa-star starflag_3" style="font-size:20px;"></i>      
                      </el-dropdown-item>
                      <el-dropdown-item :command="composeValue('2',scope.row.formid)"> 
                        <i class="fa fa-star starflag_2" style="font-size:20px;"></i>
                      </el-dropdown-item>
                      <el-dropdown-item :command="composeValue('1',scope.row.formid)"> 
                        <i class="fa fa-star starflag_1" style="font-size:20px;"></i>
                      </el-dropdown-item>
                      <el-dropdown-item :command="composeValue('0',scope.row.formid)" divided> 
                        <i class="fa fa-star-o starflag_0" style="font-size:20px;"></i>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>

              <el-table-column label="名称"  prop="scope.row.name">
                <template slot-scope="scope">
                  <span v-text="scope.row.name"></span>
                  <br>
                  <span v-if="(scope.row.tags|| []).length != 0">
                  <el-tag size="mini"  v-for="(item,index) in scope.row.tags.split(',')" :key="index">{{item}}</el-tag>
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="scope.row.category" label="分类" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.category == 'SUBJECT'">
                    患者数：{{scope.row.subjectcount}}
                    <br>
                    记录数：{{scope.row.formcountsubject}}
                  </span>
                  <span v-if="scope.row.category == 'PROJECT'">
                    
                    <br>
                    记录数：{{scope.row.formcountproject}}
                  </span>
                  <!-- <span v-text="scope.row.category"></span> -->
                </template>
              </el-table-column>
              <el-table-column label="操作" align="right"  width="180">
                <template slot-scope="scope">
                <el-link icon="el-icon-notebook-2" @click="$router.push({ path: '/form/data', query:{id: scope.row.formid,category:scope.row.category}})" :underline="false" style="font-size:20px;padding-right:8px"
                v-if="scope.row.category =='PROJECT'"></el-link>
                <el-link icon="el-icon-s-grid" @click="$router.push({ path: '/form/grid', query:{id: scope.row.formid,category:scope.row.category}})" :underline="false" style="font-size:20px;padding-right:8px"></el-link>
                <el-link icon="el-icon-edit" @click="$router.push({ path: '/form/edit', query:{id: scope.row.formid}})" :underline="false" style="font-size:20px;padding-right:8px"></el-link>
                <el-link icon="el-icon-delete" @click="deleteForm(scope.row.formid)" :underline="false" style="font-size:20px;padding-right:8px"></el-link>
                </template>
              </el-table-column>
            </el-table>

        </el-main>

      </el-container>

      
    </el-main>
    <el-aside width="250px" style="border-right: 0px solid #e7e9eb;
    position: relative;
    outline: none;
    color: #767c85;margin-top:20px;margin-bottom:20px;">
        <el-card class="box-card" style="margin-bottom:0px;">
     
          共计 {{computedTableData.length}} 个表单
          <br><br>
          <div ref="chartCategory" style="height:180px;"></div>
          <div ref="chartTag" style="height:180px;"></div>
        </el-card>

     


          <br/>
          <el-card class="box-card" v-show="this.formid!=0">
            <div slot="header" class="clearfix">
              <span>{{ formDetail.name }}</span>
              <span style="color:#606266;font-size:14px;float: right; padding: 3px 0" type="text">{{formDetail.category}}</span>
            </div>
            <div style="font-size:14px;color:#909399 !important;">{{ formDetail.description }}</div>
            <div style="text-align:center;padding:8px;">
              <img :src="formDetail.qrcode" style="width:120px;" :key="formid"/>
            </div>
            <div style="text-align:center;">
              <el-link type="primary" :href="'/api/auth/blankexcel?id=' + this.formid">下载数据模板</el-link></el-link>
            </div>
          </el-card>

      </el-aside>
  </el-container>
</template>

<script>
export default {
    data() {
      return {
        formList: [],
        formid: 0,
        formDetail: {
          name: '',
          category: '',
          description: '',
          qrcode: ''
        },
        filter_starflag:[],
        tags:'',
        filter_tag:[],
        tagminnum:1,
      }
    },
    created() {
      
    },
    mounted() {
      this.loadList();
      //this.loadCount();
      this.getTagList();
    },
    watch:{
      computedTableData(val){
        this.showChart();
      },
    },
    computed:{
      computedTableData(){
        return this.formList.filter(data => 
                    (
                        this.filter_starflag =='' || 
                        this.isContained((data.starflag||'0').split(','),this.filter_starflag)
                    )
                    &&
                    (
                        this.filter_tag =='' || 
                        this.isContained((data.tags || '').split(','),this.filter_tag)
                        //this.isContained(data.tags || ''.split(','),this.filter_tag)
                    )
                    );
      },
    },
    methods: {
      loadList() {
            this.$http.get('form/list').then((res) => {
            if(!res) return;
              this.formList = res.data.list;
            });                                                  
        },
      reloadList(){
        this.filter_starflag = [];
        this.filter_tag =[];
        this.loadList();
        this.getTagList();
      },
    

      deleteForm(formid){
        this.$confirm("确定要删除表单吗？", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.$http.post('form/delete', {'formid':formid}).then((res) => { 
                this.loadList();
                  }); 
            });
      },

      showInfo(row, col, evt) {
        
        this.$http.get('form/info', {params:{id:row.formid}}).then((res) => { 
        if(!res) return;

        var info = res.data.info;
  
        this.form = info;
            this.formid = info.formid;
            this.formDetail = info;
            this.formDetail.qrcode = '/console/form/qrcode?id=' + info.formid;
          }); 
      },
      //增加星标
      flagStar(command){
        console.log(command);
        this.$http.post('form/flagstarform', {'formid':command.formid,'starflag':command.starflag}).then((res) => { 
            this.loadList();
              }); 
      },
      composeValue(color,formid){
        return{starflag:color,formid:formid};
      },


      //过滤操作
      getTagList(){
        this.$http.get('tag/list',{params:{tagtype:'FORM',minnum:this.tagminnum}}).then((res)=>{
          if(!res) return;
          this.tags = res.data.list;
        })
      },
      showFilterTag(tagnum){
        this.tagminnum = tagnum;
        this.getTagList();
      },
      filterTag(tag){
        let tagname = tag.tagname;
        if(tagname){
          if(this.filter_tag.indexOf(tagname) >-1)
          {
            //已存在，去掉
            this.filter_tag.splice(this.filter_tag.indexOf(tagname), 1);
          }
          else
          {
            this.filter_tag.push(tagname);
          }
        }

        //清空右边的栏目信息
        this.subjectInfo = {};
        this.subjectFormData ={};

      },
      filterstarflag(value){
      
        if(this.filter_starflag.indexOf(value) >-1)
        {
          //已存在，去掉
          this.filter_starflag.splice(this.filter_starflag.indexOf(value), 1);
        }
        else
        {
          //目前星标只允许选一个，做的是并且关系，留个坑，为或关系做准备
          this.filter_starflag = [];
          this.filter_starflag.push(value);
        }
      

        //清空右边的栏目信息
        this.formid = 0
      },
      resetFilter(){
        this.filter_tag =[];
        this.filter_starflag =[];

        //清空右边的栏目信息
        this.formid = 0
      },


      isContained(aa,bb){
        if(!(aa instanceof Array) || !(bb instanceof Array) ) {
          return false;
        }
      
        for (var i = 0; i < bb.length; i++) {
          var flag = false;
          for(var j = 0; j < aa.length; j++){
            if(aa[j] == bb[i]){
              flag = true;
              break;
            }
          }
          if(flag == false){
            return flag;
          }
        }
        
        return true;
      },



      //图表
      showChart(){
        this.getChartCategory();
        this.getChartTag();
       
      },
      getChartCategory() {
        let chartCategory = this.$echarts.init(this.$refs.chartCategory);

        
        let formcount_subject= 0;
        let formcount_project =0;
        this.computedTableData.forEach(item => {
          if(item.category == "SUBJECT"){
            formcount_subject ++;
          }else if(item.category == "PROJECT"){
            formcount_project ++;
          }else{
           
          }
        
        });

        let chartData = [
          {value:formcount_subject,name:'患者应用'},
          {value:formcount_project,name:'研究应用'},
          
        ];

        let option = {
            title: {
                text: '类别',
            
            },
            tooltip: {
                trigger: 'item',
                formatter: '{b} : {c} <br>{d}%',
                confine:'true',  //限制在显示框内
            },
            series: [
                {
                    name: '应用类别',
                    type: 'pie',
                    radius: ['30%','90%'],
                    center: ['50%', '50%'],
                    data: chartData,
                    label:{
                      normal:{
                        position:'inner',
                        formatter:'{b}:{c}\n{d}%',
                        textStyle:{
                          fontWeight:'normal',
                          fontSize:10,
                        }
                      },
                    },
                    labelLine:{
                      normal:{
                        show:true,
                      }
                    }
                }
            ]
        };

        chartCategory.setOption(option);
      },

      getChartTag() {
      
        let chartTag = this.$echarts.init(this.$refs.chartTag);

        let chartData =[];

        this.computedTableData.forEach(item => {
          
          if(item.tags){
            item.tags.split(",").forEach(tag => {
               let isExist =false;
               chartData.forEach(element => {
                 if(element.name==tag) 
                 {
                    isExist=true;
                    element.value++;
                 }
               });

               if(!isExist){
                chartData.push({name:tag,value:1});
               }
               
            });
          }
          
        });

        let option = {
            title: {
                text: '标签',
            
            },
            tooltip: {
                trigger: 'item',
                formatter: '{b} : {c} <br>{d}%',
                confine:'true',
            },
            series: [
                {
                    name: '标签',
                    type: 'pie',
                    radius: ['30%','90%'],
                    center: ['50%', '50%'],
                    data: chartData,
                    label:{
                      normal:{
                        position:'inner',
                        formatter:'{b}:{c}\n{d}%',
                        textStyle:{
                          fontWeight:'normal',
                          fontSize:10,
                        }
                      },
                    },
                    labelLine:{
                      normal:{
                        show:true,
                      }
                    }
                }
            ]
        };

        chartTag.setOption(option);
      },
    }
  };
</script>

<style lang="less" scoped>

  
</style>